import {
  CONTRACT_AUTHENTICATION_INITIALIZE,
  PARTICIPANT_SET_INFORMATION,
} from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

import { fetchParticipantStatusSuccess, ParticipantAction } from '../actions';

export type SigningMethodTypeState = 'email' | 'kakao' | 'SECURE_LINK' | 'IN_PERSON' | null;

const initialState: SigningMethodTypeState = null;

export default function reducer(
  state: SigningMethodTypeState = initialState,
  action: ParticipantAction | ContractAuthenticationAction
) {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return initialState;
    case fetchParticipantStatusSuccess.type:
      return action.payload.signer.signingMethodType;
    case PARTICIPANT_SET_INFORMATION:
      return action.payload.signingMethodType ?? state;
    default:
      return state;
  }
}
